import type { GameTheme } from "./types";

/**
 * Default purple-themed color scheme
 */
export const defaultTheme: GameTheme = {
  name: "default",

  // Primary colors
  primary: 0x22dd22, // Green
  secondary: 0xffd700, // Gold
  success: 0x22dd22, // Green
  warning: 0xffd700, // Yellow
  danger: 0xff4444, // Red
  info: 0x4db8ff, // Blue

  // Background colors
  backgroundDark: 0x2d1b4e, // Dark purple
  backgroundMedium: 0x5533aa, // Medium purple
  backgroundLight: 0x7744dd, // Light purple

  // Panel colors
  panelLight: 0xffffff, // White
  panelDark: 0x3d2b5e, // Dark purple panel

  // Text colors
  textDark: 0x2d1b00, // Dark brown/black
  textLight: 0xffffff, // White

  // UI element colors
  border: 0x1a0a2e, // Very dark purple
  shadow: 0x000000, // Black
  highlight: 0xffffff, // White

  // Progress/fill colors
  progressEmpty: 0x4a3060, // Dark purple
  progressFill: 0x22dd22, // Green

  // Star colors
  starFilled: 0xffd700, // Gold
  starEmpty: 0x666666, // Gray
};

/**
 * Green-themed color scheme (like Bee Star image)
 */
export const greenTheme: GameTheme = {
  name: "green",

  primary: 0x44ff44,
  secondary: 0xffd700,
  success: 0x22dd22,
  warning: 0xff8800,
  danger: 0xff4444,
  info: 0x4db8ff,

  backgroundDark: 0x1b5e20,
  backgroundMedium: 0x2e7d32,
  backgroundLight: 0x43a047,

  panelLight: 0xffffff,
  panelDark: 0x1b4d1f,

  textDark: 0x1b3000,
  textLight: 0xffffff,

  border: 0x0d2818,
  shadow: 0x000000,
  highlight: 0xffffff,

  progressEmpty: 0x2d4a2d,
  progressFill: 0xffd700,

  starFilled: 0xffd700,
  starEmpty: 0x666666,
};

/**
 * Wood/brown-themed color scheme
 */
export const woodTheme: GameTheme = {
  name: "wood",

  primary: 0x22dd22,
  secondary: 0xffd700,
  success: 0x22dd22,
  warning: 0xffa500,
  danger: 0xff4444,
  info: 0x4db8ff,

  backgroundDark: 0x3d2817,
  backgroundMedium: 0x8b4513,
  backgroundLight: 0xa0522d,

  panelLight: 0xfff8e8,
  panelDark: 0x5d3a1a,

  textDark: 0x2d1b00,
  textLight: 0xffffff,

  border: 0x1a0f08,
  shadow: 0x000000,
  highlight: 0xffffff,

  progressEmpty: 0x5d3a1a,
  progressFill: 0xffd700,

  starFilled: 0xffd700,
  starEmpty: 0x8b7355,
};
